module.exports = __webpack_public_path__ + "static/img/OLLIE-MURPHY.613ba49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OLLIE-MURPHY.jpg
// module id = 6zVO
// module chunks = 0